module.exports = __webpack_public_path__ + "img/40_69_006_800.009c640a.jpg";